import React from 'react';
import { Select, Space, Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TAX_YEARS } from '../constants/taxConstants';

const { Option } = Select;
const { Text } = Typography;

const TaxYearSelector = ({ selectedTaxYear, onTaxYearChange }) => {
  return (
    <Space direction="horizontal" size="middle" style={{ marginBottom: 16 }}>
      <Text strong>Tax Year:</Text>
      <Tooltip title="Select tax year for calculations">
        <Select
          value={selectedTaxYear}
          onChange={onTaxYearChange}
          style={{ width: 120 }}
        >
          {Object.keys(TAX_YEARS).map((year) => (
            <Option key={year} value={year}>{year}</Option>
          ))}
        </Select>
      </Tooltip>
      {/* <InfoCircleOutlined style={{ color: '#1890ff' }} /> */}
    </Space>
  );
};

export default TaxYearSelector;